import script from "./MockExercise.vue?vue&type=script&setup=true&lang=js"
export * from "./MockExercise.vue?vue&type=script&setup=true&lang=js"

import "./MockExercise.vue?vue&type=style&index=0&id=4c7c95a3&lang=css"

const __exports__ = script;

export default __exports__